import EventBus from '@/scripts/event-bus';

export const OpportunityWidgetMixin = {
    computed: {
        opportunity() {
            return this.contextStore.state.opportunity;
        },

        editingContext() {
            return this.contextStore.state.editingContext;
        },

        isEditingOpportunity() {
            return this.contextStore.getters.isEditingOpportunity;
        },

        isNewOpportunity() {
            return this.contextStore.getters.isNewOpportunity;
        },

        isLoading() {
            return this.contextStore.state.loading;
        },

        isSaving() {
            return this.contextStore.state.saving;
        },

        clientId() {
            return this.contextStore.getters.clientId;
        },

        submitted() {
            return this.contextStore.state.submitted;
        },

        customFields() {
            return this.contextStore.state.customFields;
        },

        isSimpleEntry() {
            return this.opportunity.pricingDetails === 'simple';
        },

        isItemizedEntry() {
            return this.opportunity.pricingDetails === 'itemized';
        },

        hasMetMinimumGrossMargin() {
            return this.contextStore.getters.hasMetMinimumGrossMargin;
        },

        grossMarginStyles() {
            const { amount } = this.opportunity.grossMargin;
            if (amount === 0) {
                return {};
            } else if (this.hasMetMinimumGrossMargin) {
                return {
                    color: '#2ada2b',
                    'font-weight': 'bold'
                };
            } else {
                return {
                    color: '#f30070',
                    'font-weight': 'bold'
                };
            }
        },

        upfrontPayment: {
            get() {
                return this.opportunity.itemizedEntry.upfrontPayment;
            },

            set(value) {
                this.updateOpportunity((o) => {
                    o.itemizedEntry.upfrontPayment = value;
                });
            }
        },

        annualPayment: {
            get() {
                return this.opportunity.itemizedEntry.annualPayment;
            },

            set(value) {
                this.updateOpportunity((o) => {
                    o.itemizedEntry.annualPayment = value;
                });
            }
        }
    },

    methods: {
        updateOpportunity(updateFn) {
            this.contextStore.commit('updateOpportunity', updateFn);
        },

        getProfilePicture(src) {
            return src ? src : require('@/assets/images/avatar.png');
        },

        getTooltipOptions(content) {
            return {
                content,
                placement: 'top',
                offset: 5
            };
        },

        validateAndSave() {
            if(!this.isNewOpportunity || !this.isEditingOpportunity) {
                return Promise.resolve();
            }

            EventBus.$emit('opportunity-widget:validate-and-save');

            return new Promise((resolve, reject) => {
                if (this.isSaving) {
                    const unsubscribe = this.contextStore.subscribe((mutation) => {
                        if (mutation.type === 'setSaving' && mutation.payload === false) {
                            resolve();
                            unsubscribe();
                        }
                    });
                } else {
                    reject();
                }
            });

        },
    }
};